import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PageVisibilityService {

    private _visible = new BehaviorSubject<boolean>(
        !document.hidden
    );

    visible$ = this._visible.asObservable();

    constructor() {
        fromEvent(document, 'visibilitychange')
            .subscribe(() => {
                this._visible.next(!document.hidden);
            });
    }

    isVisible(): boolean {
        return !document.hidden;
    }
}